import React from "react";
import "./landing.css";
import heroImg from "../../assets/efefe.jpeg"; 
import { Link } from "react-router-dom";

const Landing = () => {
  const metrics = [
    { value: "24/7", label: "تجربة سلسة" },
    { value: "+10K", label: "مستخدم يتابع" },
    { value: "1", label: "هوية واضحة" },
  ]

  return (
    <section className="hero">
      <div className="hero-card">

        <div className="hero-content">
          <span className="hero-eyebrow">مؤسسة نبض المستقبل</span>

          <h1>
            خلّي شغلك <br />
            <span>
أكثر احترافية معنا</span>
          </h1>

          <p>
صناع ونبض المستقبل البكج الحديث التخصصي
          </p>

          <div className="hero-actions">
            <Link to="/login" className="hero-link primary">
              ابدأ الآن
            </Link>
            <Link to="/#about" className="hero-link secondary">
              تعرف علينا
            </Link>
          </div>

          <div className="hero-metrics">
            {metrics.map((metric) => (
              <div className="metric" key={metric.label}>
                <strong>{metric.value}</strong>
                <span>{metric.label}</span>
              </div>
            ))}
          </div>

        </div>

        <div className="hero-visual">
          <div className="hero-glow hero-glow-one"></div>
          <div className="hero-glow hero-glow-two"></div>

          <div className="hero-frame"></div>

          <img src={heroImg} alt="hero" />

          <div className="float-tag tag-1">Premium</div>
          <div className="float-tag tag-2">Elegant</div>
          <div className="float-tag tag-3">Minimal</div>
        </div>

      </div>
    </section>
  );
};

export default Landing;
